import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "mantine-react-table";

export interface StructuredNoteDetailsResponse {
  data: StructuredNoteDetailsData[];
  meta: {
    totalRowCount: number;
  };
}

export interface StructuredNoteDetailsData {
  noteId: number;
  status: string;
  tenure: number;
  issuedAt: string;
  maturityDate: string;
  totalMerchants: number;
  totalSKU: number;
  investedPrincipal: number;
  repaidPrincipal: number;
  expectedInterest: number;
  repaidInterest: number;
  repaidAdditionalInterest: number;
}

interface StructuredNoteDetailsRequest {
  token: string;
  orgRoleId: number;
  adminOrgRoleId?: number;
  pagination: MRT_PaginationState;
  columnFilters: MRT_ColumnFiltersState;
  sorting: MRT_SortingState;
  globalFilter?: string;
}

const getStructuredNoteDetails = async ({
  token,
  orgRoleId,
  adminOrgRoleId,
  pagination,
  columnFilters,
  sorting,
  globalFilter,
}: StructuredNoteDetailsRequest): Promise<StructuredNoteDetailsResponse> => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.SKU_FINANCE)}/sku-finance/dashboard/investor-structured-note-details/${orgRoleId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: {
          page: `${pagination.pageIndex + 1}`,
          pageSize: `${pagination.pageSize}`,
          columnFilters: columnFilters,
          sorting: sorting,
          globalFilter: globalFilter,
          adminOrgRoleId: adminOrgRoleId,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default getStructuredNoteDetails;
